import { render } from "./Index.vue?vue&type=template&id=5820ec87"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/PrivacyPolicy/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5820ec87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5820ec87', __exports__)) {
    api.reload('5820ec87', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=5820ec87", () => {
    api.rerender('5820ec87', render)
  })

}


export default __exports__